export default __webpack_public_path__ + "static/media/solunus.128ef388.webp";